module.exports = __webpack_public_path__ + "static/media/slide-placeholder.38643de4.png";